import React from 'react'
import Label from './label'
import { get } from 'lodash'
import { OfferDetailsType } from './types/ShoppingPageType'

interface Props {
  description: string | null
  conditions: OfferDetailsType['conditions']
}

const OfferDetailsModalInfoCard = ({ description, conditions }: Props) => {
  let expirationLabel = null
  if (get(conditions, 'length') > 0) {
    const expirationCondition = conditions[0]
    expirationLabel = (
      <Label
        className="offer-details-modal-infocard__label"
        src={expirationCondition.image.url}
        text={expirationCondition.content}
        alt={expirationCondition.image.accessibilityLabel || ''}
      />
    )
  }

  return (
    <div className="offer-details-modal-infocard">
      <div className="offer-details-modal-infocard__description ppvx_text--heading-lg">
        {description}
      </div>
      {expirationLabel}
    </div>
  )
}

export default OfferDetailsModalInfoCard
